import React from "react";
import { Container, Row, Col } from "shards-react";
import BookingQuotes from "../components/common/bookings/Quotes";

const BookingQuotesView = props => {
  return (
    <Container fluid className="main-content-container px-4">
      <BookingQuotes />
    </Container>
  );
};

export default BookingQuotesView;
